import PropTypes from 'prop-types'
import React from 'react'
import undefsafe from 'undefsafe'

import FiltersCategory from './filtersCategory'
import FiltersTags from './filtersTags'
import FiltersPrice from './filtersPrice'
import FiltersCompatibleWith from './filtersCompatibleWith'
import FiltersSoftwareVersion from './filtersSoftwareVersion'
import FiltersPolygons from './filtersPolygons'
import FiltersFileType from './filtersFileType'
import SelectedFilters from './selectedFilters'
import FiltersSize from './filtersSize'
import FiltersColors from './filtersColors'
import FiltersLength from './filtersLength'
import FiltersVocals from './filtersVocals'
import FiltersDropdown from './filtersDropdown'
import FiltersBoolean from './filtersBoolean'
import FiltersProMusic from './filtersProMusic'

const SearchFilters = ({aggregations, location, currentSite}) => {
  const basicFilters = [
    {
      Component: FiltersCategory,
      isActive: !!undefsafe(aggregations, 'category.length'),
      props: {
        categoryRootCount: undefsafe(aggregations, 'category_root_count.count'),
        items: aggregations.category
      }
    },
    {
      Component: FiltersTags,
      isActive: !!undefsafe(aggregations, 'tags.length'),
      props: {
        items: aggregations.tags
      }
    },
    {
      Component: FiltersPrice,
      isActive: true,
      props: {
        cost: aggregations.cost
      }
    },
    {
      Component: FiltersDropdown,
      isActive: true,
      props: {
        name: 'sales',
        label: 'Sales',
        ignoreOptions: ['varies'],
        items: aggregations.sales_count
      }
    },
    {
      Component: FiltersDropdown,
      isActive: undefsafe(aggregations, 'rating.length') > 0,
      props: {
        name: 'rating_min',
        label: 'Rating',
        items: aggregations.rating
      }
    }
  ]

  const extraFilters = [
    {
      Component: FiltersSoftwareVersion,
      isActive: undefsafe(aggregations, 'platform.length') > 0,
      props: {
        items: aggregations.platform,
        platformRootCount: undefsafe(aggregations, 'platform_root_count.count')
      }
    },
    {
      Component: FiltersCompatibleWith,
      isActive: undefsafe(aggregations, 'compatible_with.length') > 0,
      props: {
        items: aggregations.compatible_with
      }
    },
    {
      Component: FiltersPolygons,
      isActive: aggregations.poly_count,
      props: {
        items: aggregations.poly_count
      }
    },
    {
      Component: FiltersFileType,
      isActive: undefsafe(aggregations, 'file_formats.length') > 0,
      props: {
        items: aggregations.file_formats
      }
    },
    {
      Component: FiltersDropdown,
      isActive: undefsafe(aggregations, 'orientation.length') > 0,
      props: {
        name: 'orientation',
        label: 'Orientation',
        items: aggregations.orientation
      }
    },
    {
      Component: FiltersDropdown,
      isActive: undefsafe(aggregations, 'resolution.length') > 0,
      props: {
        name: 'resolution_min',
        label: 'Minimum resolution',
        items: aggregations.resolution
      }
    },
    {
      Component: FiltersDropdown,
      isActive: undefsafe(aggregations, 'frame_rate.length') > 0,
      props: {
        name: 'frame_rate',
        label: 'Frame rate',
        items: aggregations.frame_rate
      }
    },
    {
      Component: FiltersDropdown,
      isActive: undefsafe(aggregations, 'requires_plugins.length') > 0,
      props: {
        name: 'requires_plugins',
        label: 'Requires Plugins',
        items: aggregations.requires_plugins
      }
    },
    {
      Component: FiltersSize,
      isActive: undefsafe(aggregations, 'size.length') > 0,
      props: {
        items: aggregations.size
      }
    },
    {
      Component: FiltersColors,
      isActive: undefsafe(aggregations, 'colors.length') > 0,
      props: {
        items: aggregations.colors
      }
    },
    {
      Component: FiltersLength,
      isActive: !!aggregations.length,
      props: {
        length: aggregations.length
      }
    },
    {
      Component: FiltersVocals,
      isActive: undefsafe(aggregations, 'vocals_in_audio.length') > 0,
      props: {
        items: aggregations.vocals_in_audio
      }
    },
    {
      Component: FiltersDropdown,
      isActive: undefsafe(aggregations, 'tempo.length') > 0,
      props: {
        name: 'tempo',
        label: 'Tempo',
        ignoreOptions: ['varies'],
        items: aggregations.tempo
      }
    },
    {
      Component: FiltersBoolean,
      isActive: !!aggregations.alpha,
      props: {
        name: 'alpha',
        label: 'Alpha channel',
        count: undefsafe(aggregations, 'alpha.count')
      }
    },
    {
      Component: FiltersBoolean,
      isActive: !!aggregations.looped,
      props: {
        name: 'looped',
        label: 'Looped',
        count: undefsafe(aggregations, 'looped.count')
      }
    },
    {
      Component: FiltersProMusic,
      isActive: currentSite === 'audiojungle'
    }
  ]

  const activeBasicFilters = basicFilters.filter(filter => filter.isActive)
  const activeExtraFilters = extraFilters.filter(filter => filter.isActive)

  return (
    <div className='search-facet-panel'>
      <SelectedFilters location={location} />
      <div className='search-facet fds-u-is-hidden--no-js'>
        {activeBasicFilters.map((filter, index, list) => {
          return (
            <filter.Component
              key={index}
              location={location}
              isAtTop={index === 0}
              isAtBottom={list.length === index + 1}
              {...filter.props}
            />
          )
        })}
      </div>

      {!!activeExtraFilters.length &&
        <div className='search-facet fds-u-is-hidden--no-js'>
          {activeExtraFilters.map((filter, index, list) => {
            return (
              <filter.Component
                key={index}
                location={location}
                isAtTop={index === 0}
                isAtBottom={list.length === index + 1}
                {...filter.props}
              />
            )
          })}
        </div>
      }
    </div>
  )
}

SearchFilters.propTypes = {
  aggregations: PropTypes.object,
  location: PropTypes.object.isRequired,
  currentSite: PropTypes.string
}

SearchFilters.defaultProps = {
  aggregations: {}
}

export default SearchFilters



// WEBPACK FOOTER //
// ./client/components/filters/searchFilters.js